import { type Coordinates } from '@Src/types/deliveryLocationFormTypes';
import Cookies from 'js-cookie';

interface ApiResponse<T> {
  Data: T;
  Code: number;
  DeveloperMessage: string | null;
  Success: boolean;
  UserMessage: string | null;
}

type UserAddressDetails = {
  addressFields: any;
  autoSelectThisLocation: boolean;
  coordinates: Coordinates;
  countryCode?: string;
  deliveryInstructions?: string;
  deviceId?: string;
  isCustomAddress: boolean;
  isDisplayed: boolean;
};

const baseUrl = 'https://api.flipdish.co';

const getDeliveryLocationId = async ({
  appId,
  userAddressDetails,
  version,
}: {
  appId: string;
  userAddressDetails: UserAddressDetails;
  version?: string;
}): Promise<ApiResponse<{ DeliveryLocationId: number }>> => {
  const headers = {
    'Content-Type': 'application/json',
    'Flipdish-App-Type': 'Web',
    'Flipdish-App-Version': version || '',
    'Flipdish-White-Label-Id': appId,
    'X-Flipdish-Token': Cookies?.get('flipdish-token') || '',
    'Suppress-Auth-Cookie': 'true',
  };

  const response = await fetch(`${baseUrl}/map/DeliveryLocationForm`, {
    method: 'POST',
    headers,
    body: JSON.stringify(userAddressDetails),
  });
  return await response.json();
};

export default getDeliveryLocationId;
